export default class NotFoundError extends Error {
}
